'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressHolderStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var alignXMap = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};
var alignYMap = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};

var align = function align(_ref) {
  var alignX = _ref.alignX,
      alignY = _ref.alignY;
  return '\n  align-items: ' + alignYMap[alignY] + ';\n  justify-content: ' + alignXMap[alignX] + ';\n';
};

var style = function style(_ref2) {
  var themeFromProvider = _ref2.theme,
      customHeight = _ref2.customHeight,
      customWidth = _ref2.customWidth;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.progress.preloader,
      backgroundColor = _theme$reactackle$com.backgroundColor,
      loaderMaxWidth = _theme$reactackle$com.loaderMaxWidth,
      height = _theme$reactackle$com.height,
      width = _theme$reactackle$com.width;
  return (0, _styledComponents.css)(['background-color:', ';width:', ';height:', ';& > *{max-width:', ';}'], backgroundColor, (0, _reactackleCore.getValueString)(customWidth || width), (0, _reactackleCore.getValueString)(customHeight || height), (0, _reactackleCore.getValueString)(loaderMaxWidth));
};

var ProgressHolderStyled = exports.ProgressHolderStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ProgressHolderStyled'
})(['width:100%;height:100%;margin:auto;position:relative;pointer-events:none;display:flex;', ' ', ' & > *{width:100%;}'], style, align);

ProgressHolderStyled.displayName = 'ProgressHolderStyled';